import { rtrim } from "../util/utils";

export default class ReviewFilter {
    constructor() {

        this.ratingFilters = document.querySelector('#rating-filter-form');
        if (!this.ratingFilters) {
            return;
        }

        this.rwFilters = [];
        this.rwActiveFilterParams = {};

        this.initCheckbox();
        this.attachHandlers();
    }

    attachHandlers() {
        this.runRatingFilter(false);
        document.body.addEventListener('palram_rating_filters_clear', this.clearAllFilters.bind(this));
    }

    runRatingFilter(fireEvent = true) {
        this.setActiveFilterParams();
        this.setQuery();

        if (fireEvent) {
            document.body.dispatchEvent(new CustomEvent('palram_rating_filters_changed'))
        }
    }

    setActiveFilterParams() {
        const activeFilters = this.getActiveFilters();
        let params = {};

        activeFilters.forEach(filter => {
            params = { ...params, ...this.setAverageParams(filter, params) };
        });

        this.rwActiveFilterParams = Object.keys(params).length > 0 ? params : {};
    }

    setAverageParams(filter, params) {
        let name = filter.name;
        let data = {};

        data[name] = params[name] ? `${params[name]},${filter.value}` : filter.value;

        return data;
    }

    setQuery() {
        let uri = window.location.pathname;
        const fieldNames = this.getFilterFieldNames();

        let oldQuery = window.location.search;
        let params = new URLSearchParams(oldQuery);

        fieldNames.forEach( field => {
            params.set(field, this.rwActiveFilterParams[field]);
            if (params.has(field)) {
                if (undefined !== this.rwActiveFilterParams[field]) {
                    params.set(field, this.rwActiveFilterParams[field]);
                } else {
                    params.delete(field);
                }
            } else {
                if (undefined !== this.rwActiveFilterParams[field]) {
                    params.append(field, this.rwActiveFilterParams[field]);
                }
            }
        });

        if (params) {
            uri += `?${params}`;
        }
        uri = rtrim(uri, '?');

        window.history.replaceState({}, "", decodeURIComponent(uri));
    }

    initCheckbox() {
        const filterElems = this.ratingFilters.querySelectorAll('input[type="checkbox"]');

        if (filterElems) {
            filterElems.forEach(el => {
                el.addEventListener('change', this.onChangeCheckbox.bind(this));

                let data = {
                    name: el.name,
                    key: el.id,
                    el,
                    active: el.checked,
                    value: el.value,
                }

                this.rwFilters.push(data);
            });
        }
    }

    onChangeCheckbox(event) {
        const filterKey = event.target.id

        const filterIndex = this.getFilterIndexByKey(filterKey);

        if (!event.target.checked) {
            this.clearFilter(filterIndex);

        } else {
            this.updateFilterData(filterIndex, { active: true });
        }

        this.onFilterChange(filterIndex, true);
    }

    updateFilterData(index, data) {
        if (undefined !== this.rwFilters[index]) {
            this.rwFilters[index] = { ...this.rwFilters[index], ...data };
        }
    }

    onFilterChange(index, force = false) {
        if (undefined === index) {
            return;
        }

        if (force) {
            this.runRatingFilter(true);
        }
    }

    clearFilter(index, updateEvent = false) {
        if (undefined === this.rwFilters[index]) {
            return;
        }

        let data = {
            active: false,
        }

        this.updateFilterData(index, data);

        this.rwFilters[index].el.checked = false;

        if (updateEvent) {
            this.onFilterChange(index);
        }
    }

    clearAllFilters() {
        this.rwFilters.forEach((filter, index) => {
            this.clearFilter(index, false);
        });

        this.runRatingFilter(true);
    }

    getActiveFilters() {
        return this.rwFilters.filter(filter => filter.active);
    }

    getFilterIndexByKey(key) {
        return this.rwFilters.findIndex(elem => {
            return elem.key && elem.key === key;
        });
    }

    get params() {
        return this.rwActiveFilterParams;
    }

    getFilterFieldNames() {
        let names = this.rwFilters.map(filter => {
            return [filter.key, filter.name];
        }).flat();

        return names.filter((value, index, self) => self.indexOf(value) === index);
    }
}
